import '../sass/timeline.scss';

(() => {
    const $timelines = document.querySelectorAll('.timeline');

    if (!$timelines) return;

    $timelines.forEach($timeline => {
        const $imageCarousel = $timeline.querySelector('.timeline__image-carousel');
        const $yearCarousel = $timeline.querySelector('.timeline__year-carousel');
        const $textCarousel = $timeline.querySelector('.timeline__text-carousel');

        const $yearSlideButtons = $timeline.querySelectorAll('.timeline__year-slide-button');

        const $carouselControlsNext = $timeline.querySelector('.timeline__carousel-controls-next');
        const $carouselControlsPrev = $timeline.querySelector('.timeline__carousel-controls-prev');

        const initCarousels = () => {
            let yearCarousel, textCarousel, imageCarousel;

            if ($yearCarousel) {
                yearCarousel = new Swiper($yearCarousel, {
                    allowTouchMove: false,
                    slidesPerView: 'auto',
                    centeredSlides: true,
                });
            }

            if ($textCarousel) {
                textCarousel = new Swiper($textCarousel, {
                    allowTouchMove: false,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    autoHeight: true,
                });
            }

            if ($imageCarousel) {
                imageCarousel = new Swiper($imageCarousel, {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    navigation: {
                        nextEl: $carouselControlsNext,
                        prevEl: $carouselControlsPrev,
                    },
                    controller: {
                        control: [yearCarousel, textCarousel],
                    }
                });
            }

            if ($yearSlideButtons && imageCarousel) {
                $yearSlideButtons.forEach($yearSlideButton => {
                    $yearSlideButton.addEventListener('click', () => {
                        const { slideIndex } = $yearSlideButton?.dataset;

                        if (!slideIndex) return;
                        
                        imageCarousel.slideTo(slideIndex);
                    });
                });
            }
        };

        initCarousels();
    });
})();
